import React from 'react'
import styled from 'styled-components'
import {
  space,
  width,
  fontSize,
  color,
  maxWidth,
  textAlign,
} from 'styled-system'

const Text = styled('p')`
  ${space} ${width} ${fontSize} ${color} ${maxWidth} ${textAlign};
`

export default Text



// WEBPACK FOOTER //
// ./src/components/Text.js